/* eslint-disable max-len */

import { useCaseOptions } from 'Pods/ThreeDStudio/Components/MainPanel/Components/LeftSide/Components/ModelSettings/Components/UseCaseSelector/useCaseOptions'

const clampToRange = (value, { minimum, maximum } = {}) => {
  if (minimum == null || maximum == null) {
    return value
  }

  return Math.min(Math.max(Number(value), minimum), maximum)
}

const matchesPresetValue = (key, presetValue, settingValue, range) => {
  // The polycount control clamps a preset target the active range cannot hold
  // (the Low Poly 20000 exceeds image-to-3D's 15000 cap), so compare within it.
  if (key === 'targetPolycount') {
    return settingValue != null && settingValue !== ''
      && clampToRange(settingValue, range) === clampToRange(presetValue, range)
  }

  return settingValue === presetValue
}

/**
 * Finds the use case whose preset the given model settings match, so a preset is
 * highlighted again once manual changes land back on its values. The preset provider
 * is not compared: switching engines never deselects a use case. No preset covers
 * extra quality, so settings with it on match none.
 *
 * @param {Object} modelSettings - The modelSettings slice.
 * @param {Object} [range] - The active { minimum, maximum } polycount range.
 * @returns {string|undefined} One of USE_CASE values.
 */
export function findMatchingUseCase(modelSettings, range) {
  if (modelSettings.extraQuality) {
    return undefined
  }

  const match = useCaseOptions.find(({ preset }) => (
    Object.entries(preset).every(([key, value]) => (
      key === 'provider' || matchesPresetValue(key, value, modelSettings[key], range)
    ))
  ))

  return match?.id
}
